module.exports = __webpack_public_path__ + "static/media/over-ons_hero--bg.d9f82c93.jpg";